import { apiUrl } from "helpers/constants/config.constants";
import { httpPost, httpGet } from "./http.service";
import { User } from "./user.service";

export let authUser: User | undefined;

export const getAuthUser = () => {
  return JSON.parse(localStorage.getItem("authUser") as string) as User;
}

export const login = (email: string, password: string) => {
  return new Promise((resolve, reject) => {
    httpPost(apiUrl.auth.login, { username: email, password }).then((res: any) => {
      authUser = res.user as User;
      resolve(res)
    }).catch((error) => {
      reject(error)
    })
  });
}

export const register = (email: string, password: string) => {
  return new Promise((resolve, reject) => {
    try {
      const response = httpPost(apiUrl.auth.register, { email, password });
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
}

export const doGetRoleAccess = () => {
  return new Promise((resolve, reject) => {
    httpGet(apiUrl.roleAccess.list).then((res: any) => {
      resolve(res)
    }).catch((error) => {
      reject(error)
    })
  });
}

export const doFirstTimeLogin = (userId: string, password: string) => {
  return new Promise((resolve, reject) => {
    try {
      httpPost(apiUrl.auth.firstChangePassword, { userId, password }).then((res: any) => {
        resolve(res)
      }).catch((error) => {
        reject(error)
      })
    } catch (error) {
      reject(error);
    }
  })
}

export const doChangeProject = (projectId: string) => {
  return new Promise((resolve, reject) => {
    httpPost(apiUrl.auth.changeProject, { projectId }).then((res: any) => {
      const response = res
      localStorage.setItem("authUser", JSON.stringify(response.user))
      localStorage.setItem("authProject", JSON.stringify(response.project))
      localStorage.setItem("accessToken", response.accessToken)
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  })
}